import { Link } from 'react-router-dom';
import ArticleLayout from '@/components/feature/ArticleLayout';
import { featuredArticles } from '@/mocks/articles';

export default function KakobuyGuide() {
  return (
    <ArticleLayout
      title="Przewodnik Zakupowy Kakobuy — wszystko co musisz wiedzieć"
      subtitle="Kompletny przewodnik po zakupach z Chin przez agenta Kakobuy. Od rejestracji po odbiór paczki — wszystkie informacje w jednym miejscu."
      category="Przewodnik"
      date="Aktualizacja: Czerwiec 2026"
      breadcrumbLabel="Przewodnik Zakupowy"
    >
      <div className="max-w-4xl mx-auto">
        <div className="space-y-12">
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">Twój kompletny przewodnik po Kakobuy</h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>Witaj w kompleksowym przewodniku zakupowym <strong>Kakobuy</strong>. Niezależnie od tego czy dopiero zaczynasz swoją przygodę z zakupami z Chin, czy jesteś już doświadczonym kupującym — znajdziesz tu wszystkie niezbędne informacje. Nasz przewodnik łączy najważniejsze artykuły i poradniki w jednym miejscu.</p>
              <p>Poniżej znajdziesz odnośniki do wszystkich kluczowych tematów: od podstaw <strong>Kakobuy Spreadsheet</strong>, przez instrukcje zakupowe, po analizę kosztów i bezpieczeństwa.</p>
            </div>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">Spis tematów przewodnika</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { to: '/co-to-jest-kakobuy-spreadsheet', title: 'Co to jest Kakobuy Spreadsheet?', desc: 'Podstawy i definicja arkusza zakupowego' },
                { to: '/jak-kupowac-przez-kakobuy', title: 'Jak kupować przez Kakobuy?', desc: 'Instrukcja krok po kroku' },
                { to: '/poradnik-dla-poczatkujacych', title: 'Poradnik dla początkujących', desc: 'Od zera do pierwszego zamówienia' },
                { to: '/co-to-jest-qc', title: 'Co to jest QC?', desc: 'Kontrola jakości wyjaśniona' },
                { to: '/jak-sprawdzac-qc', title: 'Jak sprawdzać QC?', desc: 'Praktyczna analiza zdjęć' },
                { to: '/czy-kakobuy-jest-bezpieczny', title: 'Czy Kakobuy jest bezpieczny?', desc: 'Analiza bezpieczeństwa' },
                { to: '/koszty-wysylki', title: 'Koszty wysyłki', desc: 'Pełne zestawienie cen' },
                { to: '/najlepszy-kakobuy-spreadsheet', title: 'Najlepszy Spreadsheet', desc: 'Ranking i porównanie' },
                { to: '/darmowy-spreadsheet', title: 'Darmowy Spreadsheet', desc: 'Gdzie znaleźć i jak używać' },
              ].map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className="flex flex-col p-5 bg-background-100 rounded-xl border border-background-200/60 hover:border-accent-200 transition-all cursor-pointer"
                >
                  <h3 className="font-semibold text-foreground-950 mb-1 hover:text-primary-600 transition-colors">{item.title}</h3>
                  <p className="text-sm text-foreground-600">{item.desc}</p>
                </Link>
              ))}
            </div>
          </section>

          <div className="bg-primary-50 border border-primary-200 rounded-2xl p-8 md:p-10 text-center">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">Przejdź do arkusza!</h3>
            <p className="text-sm md:text-base text-foreground-600 mb-6 max-w-md mx-auto">Otwórz pełny Kakobuy Spreadsheet i zacznij przeglądać produkty.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 rounded-full transition-all whitespace-nowrap cursor-pointer">
                Kakobuy Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line text-sm"></i></span>
              </a>
              <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-primary-600 hover:text-primary-700 border border-primary-200 hover:border-primary-300 rounded-full transition-all whitespace-nowrap cursor-pointer">
                Strona główna
              </Link>
            </div>
          </div>

          <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
            '@context': 'https://schema.org', '@type': 'Article',
            headline: 'Przewodnik Zakupowy Kakobuy — wszystko co musisz wiedzieć',
            description: 'Kompletny przewodnik po zakupach z Chin przez agenta Kakobuy.',
            author: { '@type': 'Organization', name: 'Kakobuy.study' },
            datePublished: '2026-06-21', dateModified: '2026-06-21', inLanguage: 'pl-PL',
            publisher: { '@type': 'Organization', name: 'Kakobuy.study' },
          }) }} />
        </div>
      </div>
    </ArticleLayout>
  );
}